import { FiAlertTriangle } from "react-icons/fi";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

/** `/portal/cookies` — static landing shown when the portal session cookie /
 * storage can't be set, so the client knows to enable cookies and retry. */
export function NeedCookies() {
  return (
    <div className="mx-auto w-full max-w-md">
      <Card>
        <CardHeader className="items-center text-center">
          <span className="bg-muted text-muted-foreground mb-2 flex size-12 items-center justify-center rounded-full">
            <FiAlertTriangle className="size-6" aria-hidden />
          </span>
          <CardTitle className="text-xl">Cookies required</CardTitle>
        </CardHeader>
        <CardContent className="text-muted-foreground text-center text-sm">
          <p>
            Your browser is blocking cookies or storage, which the portal needs
            to keep you signed in. Please enable cookies and storage for this
            site, then reload the page to continue.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
